import React from "react";
import { Col, Row } from "react-bootstrap";
import Image from "../assets/portfolio/top-image.svg";
import NavbarComponent from "../components/NavbarComponent";
import { motion } from "framer-motion";
import HireUsModal from "../components/HireUsModal";

function TopBgComponent() {
  return (
    <motion.div className="background-portfolio">
      <div className="overlay">
        <div className="container">
          <NavbarComponent />
          <div className="flex-top">
            <Row>
              <Col xs={12} md={6}>
                <img src={Image} alt="..." className="topImage img-fluid" />
              </Col>
              <Col className="text-col text" xs={12} md={6}>
                <div>
                  <h4>Our Portfolio</h4>
                  <p>
                    Take look at our work. It'll give a decent understanding of
                    our working area.
                  </p>
                  <HireUsModal />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default TopBgComponent;
